import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, FeatureState } from './page-edit-screen.reducer';

const featureSelector = createFeatureSelector<FeatureState>(featureKey);

export const selectCxbPage = createSelector(featureSelector, (state) => state.page);

export const selectCxbPageVersion = createSelector(featureSelector, (state) => state.page);

export const selectCxbUserSegments = createSelector(featureSelector, (state): string[] => state.userSegments);

export const selectCxbCountryCodes = createSelector(featureSelector, (state): string[] => state.countryCodes);
